interface SectionProps {
  title: string;
  children: React.ReactNode;
}

/** Card shell shared by the live Hub panels — same chrome as `SettingsTab`. */
export default function Section({ title, children }: SectionProps): JSX.Element {
  return (
    <section className="rounded-lg border border-surface-border bg-surface-card p-24">
      <h2 className="text-on-surface hd-6">{title}</h2>
      <div className="mt-16">{children}</div>
    </section>
  );
}
